import { createBrowserRouter } from 'react-router-dom';
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './screen/Dashboard';
import Management from './screen/Management';
import SendNotification from './screen/SendNotification';
import ProtectedRoute from './api/ProtectedRoute';
// import Profile from './screen/Profile';
import Product from './screen/Product';
import SupplierDetail from './screen/SupplierDetail';
import Cart from './components/Cart';
import ContentManagement from './screen/ContentManagement';
import NewsAndEvents from './screen/NewsAndEvents';
import QueriesManagement from './screen/QueriesManagement';
import OrderManagement from './screen/OrderManagement';
import OrderDetail from './screen/OrderDetail';
import CustomerRestaurantDetail from './screen/CustomerRestaurantDetail';
import NewsAndEventsDetail from './screen/NewsAndEventsDetail';
import StripePaymentComponent from './components/Stripe/StripePaymentComponent';
import Success from './screen/Success';
import Notification from './components/Notification';
import AddMenu from './screen/AddMenu';
import MenuDetails from './screen/MenuDetails';
import RestaurantManagement from './screen/RestaurantManagement';
import CustomerManagement from './screen/CustomerManagement';
import MenuManagement from './screen/MenuManagement';
import SupplierManagement from './screen/SupplierManagement';

const router = createBrowserRouter([
    {
        path: "/",
        element: <Login />
    },
    {
        path: '/admin-dashboard',
        element: <Layout />,
        children: [
            {
                index: true,
                element: <ProtectedRoute element={< Dashboard />} />
            },
            {
                path: 'menu-management',
                element: <ProtectedRoute element={<MenuManagement />} />
            },
            {
                path: 'add-menu',
                element: <ProtectedRoute element={<AddMenu />} />
            },
            {
                path: 'menu-management/:id',
                element: <ProtectedRoute element={<MenuDetails />} />
            },
            {
                path: 'suppliers-management',
                element: <ProtectedRoute element={<SupplierManagement />} />
            },
            {
                path: 'supplier-detail/:id',
                element: <ProtectedRoute element={< SupplierDetail />} />
            },
            {
                path: 'restaurants-management',
                element: <ProtectedRoute element={<RestaurantManagement />} />
            },
            {
                path: 'restaurant-detail/:id',
                element: <ProtectedRoute element={<CustomerRestaurantDetail />} />
            },
            {
                path: 'customer-management',
                element: <ProtectedRoute element={<CustomerManagement />} />
            },
            {
                path: 'customer-detail/:id',
                element: <ProtectedRoute element={<CustomerRestaurantDetail />} />
            },
            {
                path: 'product-management',
                element: <ProtectedRoute element={<Management />} />
            },
            {
                path: 'add-product',
                element: <ProtectedRoute element={<Product />} />
            },
            {
                path: 'order-management',
                element: <ProtectedRoute element={<OrderManagement />} />
            },
            {
                path: 'order-detail/:role/:id',
                element: <ProtectedRoute element={<OrderDetail />} />
            },
            {
                path: 'news-and-events-management',
                element: <ProtectedRoute element={<Management />} />
            },
            {
                path: 'add-news-and-events',
                element: <ProtectedRoute element={<NewsAndEvents />} />
            },
            {
                path: 'news-and-events/:id',
                element: <ProtectedRoute element={<NewsAndEventsDetail />} />
            },
            {
                path: 'content-management',
                element: <ProtectedRoute element={<ContentManagement />} />
            },
            {
                path: 'queries-management',
                element: <ProtectedRoute element={<QueriesManagement />} />
            },
            {
                path: 'send-notifications',
                element: <SendNotification />
            },
            // {
            //     path: 'profile',
            //     element: <Profile />
            // },
            {
                path: 'cart',
                element: <Cart />
            },
            {
                path: 'notification',
                element: <Notification />
            },

        ]
    },
    {
        path: "/payment",
        element: <StripePaymentComponent />
    },
    {
        path: 'success',
        element: <Success />
    }
])

export default router;